var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100p ov-a"},[(_vm.show)?_c(_vm.item.component,{tag:"component",attrs:{"data":_vm.data,"option":_vm.item.option,"widget":_vm.item}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }